'use client';

import { cn } from '@repo/utils/cn';
import SidebarContent from '@/components/layout/sidebar-left/sidebar-content';
import { useAppStore } from '@/providers/AppStoreProvider';

const SidebarLeft = () => {
  const {
    sidebarOpen,
    activeSidebarSection,
    setActiveSidebarSection,
    accessToken: isAuthenticated,
  } = useAppStore((state) => ({
    sidebarOpen: state.sidebarOpen,
    activeSidebarSection: state.activeSidebarSection,
    setActiveSidebarSection: state.setActiveSidebarSection,
    accessToken: state.accessToken,
  }));

  return (
    <aside
      className={cn(
        'hide-scrollbar transition-width hidden duration-200 sm:block',
        sidebarOpen ? 'w-[240px]' : 'w-[65px]'
      )}
    >
      <div
        className={cn(
          'hide-scrollbar transition-width fixed flex h-[calc(100vh-(var(--vt-header-nav-bar-height-sm)))] flex-col overflow-hidden border-r border-[var(--surface-lighter-bg)] duration-200 vt-containers-sidebar-bg',
          sidebarOpen ? 'w-[240px]' : 'w-[65px]'
        )}
      >
        <div className="flex-grow overflow-auto">
          <SidebarContent
            sidebarOpen={sidebarOpen}
            isAuthenticated={!!isAuthenticated}
            activeSidebarSection={activeSidebarSection}
            setActiveSidebarSection={setActiveSidebarSection}
          />
        </div>
      </div>
    </aside>
  );
};

export default SidebarLeft;
